import type { ReactNode } from 'react';
import { DASH } from '../lib/format';

export interface StatProps {
  label: string;
  value: ReactNode | null;
  /** Shown when value is null — say why there is no number (never render 0 for "unknown"). */
  nullReason?: string;
  detail?: ReactNode;
}

export function Stat({ label, value, nullReason, detail }: StatProps) {
  const isNull = value === null || value === undefined;
  return (
    <div className="flex min-w-0 flex-col gap-1 rounded-md border-hair bg-sheet px-4 py-3 shadow-1">
      <dt className="text-sm font-medium text-ink-2">{label}</dt>
      <dd className="m-0 font-sans text-2xl font-semibold tracking-tight tabular-nums">{isNull ? DASH : value}</dd>
      {isNull && nullReason ? <dd className="m-0 text-xs text-ink-2">{nullReason}</dd> : null}
      {!isNull && detail ? <dd className="m-0 text-xs text-ink-2">{detail}</dd> : null}
    </div>
  );
}

export function StatStrip({ children, label }: { children: ReactNode; label: string }) {
  return (
    <dl aria-label={label} className="m-0 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
      {children}
    </dl>
  );
}
